import { useCompanyMutations } from "@app/entities/company/mutations";
import { useCompany } from "@app/providers/CompanyContextProvider";
import Form from "antd/lib/form";
import { useEffect } from "react";

export const useNotificationsLoader = () => {
  const { selectedCompany } = useCompany();
  const [notificationsForm] = Form.useForm();

  useEffect(() => {
    if (!selectedCompany) return;
    const { lowBalanceEmail, lowBalanceThreshold, staleReportsEmail } =
      selectedCompany;
    notificationsForm.setFieldsValue({
      lowBalanceEmail,
      lowBalanceThreshold: (lowBalanceThreshold ?? 0) / 100,
      staleReportsEmail,
    });
  }, [selectedCompany]);

  const { updateNotifications, isMutationPending } = useCompanyMutations();

  const handleUpdateNotifications = () => {
    const { lowBalanceEmail, staleReportsEmail, lowBalanceThreshold } =
      notificationsForm.getFieldsValue();
    const notificationsData = {
      lowBalanceEmail,
      staleReportsEmail,
      lowBalanceThreshold: lowBalanceThreshold * 100,
    };
    updateNotifications(notificationsData);
  };

  const isLoading = isMutationPending;

  return {
    notificationsForm,
    handleUpdateNotifications,
    isLoading,
  };
};
